import './header.css'
import img from '../../utils/jagu-logo/jagu-white-logo.png'
import { Link, NavLink } from 'react-router-dom'
import AuthButton from '../../AuthButton/AuthButton'

const Header = () => {
  return (
    <div className="container">
      <Link to="/" className="first-blok">
        <img className="img-logo" src={img} alt="logo" />
        <h1>JAGU-MOOK</h1>
      </Link>
      <div className="second-blok">
        <div className="container-catalogs">
          <NavLink to="/about" className={({ isActive }) => (isActive ? 'navigators' : 'noneNav')}>
            О нас
          </NavLink>
          <NavLink
            to="/courses"
            className={({ isActive }) => (isActive ? 'navigators' : 'noneNav')}
          >
            Курсы
          </NavLink>
        </div>

        <AuthButton />
      </div>
    </div>
  )
}

export default Header
